import { Switch } from '@postscript/components';
import { useAgentActions } from 'controllers/contexts/agentActions';
import useAuth from 'hooks/useAuth';
import styled from 'styled-components';

const StyledSwitch = styled.div`
  margin-right: var(--spacing-2);
`;

const ToggleAgentActionRecording = () => {
  const { isRecording, toggleRecording }: any = useAgentActions();
  const { userHasLegacyRole } = useAuth();

  const isAiAlphaTester = userHasLegacyRole('AI_ALPHA_TESTER');

  // Don't allow toggling for non-AI users
  if (!isAiAlphaTester) return <></>;

  return (
    <StyledSwitch>
      <Switch
        id="agent-action-recording"
        label="Recording Actions"
        checked={isRecording}
        fieldSize="small"
        onChange={toggleRecording}
      />
    </StyledSwitch>
  );
};

export default ToggleAgentActionRecording;
